export const ACTION_TYPE_UNDEFINED = undefined;
export const ACTION_TYPE_ADD_TAG = 1;
export const ACTION_TYPE_SET_CARRIER_SERVICE_PACKAGE = 2;
// type #3 looks like it is not supported v2 doesn't show this as an option
export const ACTION_TYPE_INSURE_PACKAGE = 4;
export const ACTION_TYPE_REQUEST_CONFIRMATION = 5;
export const ACTION_TYPE_ADD_INTERNAL_NOTE = 6;
export const ACTION_TYPE_HOLD_ORDER_FOR = 7;
export const ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE = 8;
export const ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY = 9;
export const ACTION_TYPE_SET_SHIP_FROM_LOCATION = 10;
export const ACTION_TYPE_STOP_PROCESSING_RULES = 11;
export const ACTION_TYPE_SEND_AN_EMAIL = 12;
export const ACTION_TYPE_CREATE_ALERT = 13;
export const ACTION_TYPE_SET_ORDER_TOTAL_WEIGHT = 14;
export const ACTION_TYPE_SET_PACKAGE_DIMENSIONS = 15;
export const ACTION_TYPE_DONT_IMPORT_ORDER = 16;
export const ACTION_TYPE_ADJUST_ORDER_WEIGHT = 17;
export const ACTION_TYPE_HOLD_UNTIL = 18;
export const ACTION_TYPE_MARK_SHIPMENT_NON_MACHINABLE = 19;
export const ACTION_TYPE_SHOW_POSTAGE_PAID = 20;
export const ACTION_TYPE_USE_SHIPMENT_NOTIFICATION_TEMPLATE = 21;
export const ACTION_TYPE_USE_PACKING_SLIP = 22;
export const ACTION_TYPE_ADD_NOTE_TO_BUYER = 23;
export const ACTION_TYPE_ASSIGN_TO_USER = 24;
export const ACTION_TYPE_BILL_INTL_DUTIES_TO_PAYOR = 25;
export const ACTION_TYPE_DONT_PREPAY_POSTAGE = 26;
export const ACTION_TYPE_CHARGE_SHIPPING_TO_THIRD_PARTY = 27;
export const ACTION_TYPE_SET_FULFILLMENT_PROVIDER = 28;
export const ACTION_TYPE_DONT_NOTIFY_MARKETPLACE_OF_SHIPMENT = 29;
export const ACTION_TYPE_SET_CUSTOM_FIELD_ONE = 30;
export const ACTION_TYPE_SET_CUSTOM_FIELD_TWO = 31;
export const ACTION_TYPE_SET_CUSTOM_FIELD_THREE = 32;
export const ACTION_TYPE_ENABLE_SATURDAY_DELIVERY = 33;
export const ACTION_TYPE_SET_ORER_AS_CONTAINING_ALCOHOL = 34;
export const ACTION_TYPE_SET_ORER_AS_CONTAINING_DRY_ICE = 35;
export const ACTION_TYPE_ENABLE_SHIPPER_RELEASE = 36;
export const ACTION_TYPE_SET_DRY_ICE_WEIGHT = 37;
export const ACTION_TYPE_SET_DECLARATION_STATEMENT = 38;
export const ACTION_TYPE_INCLUDE_RETURN_LABEL_WITH_OUTBOUND = 39;
export const ACTION_TYPE_USE_DELIVERY_NOTIFICATION_EMAIL_TEMPLATE = 40;
export const ACTION_TYPE_SET_ORDER_AS_DANGEROUS_GOODS = 41;
export const ACTION_TYPE_SET_SHIP_BY_DATE = 42;
export const ACTION_TYPE_CHARGE_SHIPPING_TO_MY_ACCOUNT = 43;
export const ACTION_TYPE_COLLECT_PAYMENT_ON_DELIVERY = 44;
export const ACTION_TYPE_ADD_TAX_IDENTIFERS = 45;
export const ACTION_TYPE_SET_SERVICE_COLLECTION = 46;
export const ACTION_TYPE_SET_PREPAY_DUTIES_AND_TAXES = 47;
export const ACTION_TYPE_USE_BLANK_BOX = 48;
export const ACTION_TYPE_BLOCK_AMAZON_LOGISTICS = 49;
export const ACTION_TYPE_DELEGATE_TO_ASSIGNED_FULFILLMENT_PROVIDER = 50;
export const ACTION_TYPE_SEND_CARRIER_NOTIFICATIONS = 51;
export const ACTION_TYPE_SET_DELIVER_BY_DATE = 52;
export const ACTION_TYPE_SET_CONTAINS_DANGEROUS_GOODS = 53;
export const ACTION_TYPE_ADD_SHIPMENT_ITEM = 54;
export const ACTION_TYPE_ADD_IMPORTER_OF_RECORD = 55;
export const ACTION_TYPE_ADD_SERVICE_LEVEL_ROYAL_MAIL = 56;
export const ACTION_TYPE_SET_SHIP_DATE = 57;
export const ACTION_TYPE_RUN_PACKING_RECOMMENDATION = 58;
export const ACTION_TYPE_ADD_MOVEMENT_INDICATOR = 59;
export const ACTION_TYPE_READY_TO_PICK = 60;
export const ACTION_TYPE_FULFILL_WITH_FREIGHT = 61;
export const ACTION_TYPE_APPLY_HANDLING_UNIT_PRESET = 62;
export const ACTION_TYPE_APPLY_REFERENCES = 63;

export const LTL_FREIGHT_ACTION_TYPE_IDS = new Set([
  ACTION_TYPE_FULFILL_WITH_FREIGHT,
  ACTION_TYPE_APPLY_HANDLING_UNIT_PRESET,
  ACTION_TYPE_APPLY_REFERENCES,
]);
